'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationAlerts', ['$scope', function ($scope) {
        $scope.resetInvestigation();

        $scope.link = {
            state: 'internal.licensing.investigation.alert',
            params: [
                {
                    name: 'investigationAlertID',
                    field: 'id'
                },
                {
                    name: 'investigation_alert',
                    field: ''
                }
            ]
        };

        $scope.columns = [
            {
                label: 'Alert Type',
                field: 'alert_type.name',
                link: {
                    state: 'internal.licensing.investigation.alert',
                    params: [
                        {
                            name: 'investigationAlertID',
                            field: 'id'
                        },
                        {
                            name: 'investigation_alert',
                            field: ''
                        }
                    ]
                }
            },
            {
                label: 'Message',
                field: 'message_display'
            },
            {
                label: 'Created On',
                field: 'createdon',
                type: 'date'
            },
            {
                label: 'Created By',
                field: 'createdby'
            },
            {
                label: 'Retired On',
                field: 'retired_on',
                type: 'date'
            },
            {
                label: 'Retired By',
                field: 'retiredby'
            }
        ];

        $scope.filters = [
            {
                name: 'Alert Type',
                field: 'alert_type_id',
                service: 'AlertTypes'
            },
            {
                name: 'Retired',
                field: 'retired',
                options: [
                    { name: 'No', id: false },
                    { name: 'Yes', id: true }
                ]
            }
        ];
    }])
;